export default __webpack_public_path__ + "static/media/rent-benefit-img2.efa4282d.jpg";